import { Box } from '@mui/material';
import { fontWeights } from '../../theme/typography';
import { calendarUiPalette } from './calendarPalette';

export const calendarSnapshotChipTypography = {
  fontFamily: '"Roboto", sans-serif',
  fontSize: '11px',
  fontWeight: fontWeights.medium,
  lineHeight: 1.2,
  letterSpacing: '0.01em',
} as const;

interface CalendarSnapshotChipProps {
  label: string;
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
  onClick?: () => void;
  leftAccentColor?: string;
  sx?: object;
}

export default function CalendarSnapshotChip({
  label,
  backgroundColor = calendarUiPalette.eventModal.neutralChipBackground,
  color = calendarUiPalette.eventModal.neutralChipText,
  borderColor = 'transparent',
  onClick,
  leftAccentColor,
  sx,
}: Readonly<CalendarSnapshotChipProps>) {
  const chipBorderRadius = leftAccentColor ? '7px' : '10px';

  return (
    <Box
      component={onClick ? 'button' : 'span'}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: '26px',
        px: 1.1,
        pl: leftAccentColor ? 1.55 : 1.1,
        borderRadius: chipBorderRadius,
        overflow: 'hidden',
        border: `1px solid ${borderColor}`,
        backgroundColor,
        color,
        ...calendarSnapshotChipTypography,
        whiteSpace: 'nowrap',
        cursor: onClick ? 'pointer' : 'default',
        appearance: 'none',
        transition: onClick ? 'background-color 0.16s ease, border-color 0.16s ease, transform 0.16s ease' : undefined,
        '&::before': leftAccentColor
          ? {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: '4px',
              borderRadius: `${chipBorderRadius} 0 0 ${chipBorderRadius}`,
              backgroundColor: leftAccentColor,
            }
          : undefined,
        '&:hover': onClick
          ? {
              transform: 'translateY(-1px)',
              backgroundColor,
              borderColor,
            }
          : undefined,
        ...sx,
      }}
    >
      {label}
    </Box>
  );
}
